__turbopack_context__.v({
  "grid": "FoldersView-module__KcRJ7q__grid",
});
